import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const hijriCalendar = createApi({
    reducerPath: 'hijriCalendar',
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({

        getHijriCalendar: builder.query({
            query: ({ year, variation, mode }) => {
                const params = new URLSearchParams({ year, mode });
                // 0 is a real adjustment too.
                if (variation !== undefined && variation !== null && variation !== '') {
                    params.append('variation', variation);
                }
                return {
                    url: `/api/date-and-time/g-to-h-calender?${params.toString()}`,
                    method: 'GET',
                };
            },
        }),

    }),
});

export const {
    useLazyGetHijriCalendarQuery
} = hijriCalendar;
